"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectHubConnection = void 0;
const HMACAuthenticator = __importStar(require("hmac-authenticator"));
const msgpack = __importStar(require("msgpack-lite"));
class DirectHubConnection {
    constructor(url, formatType = "msgpack", timeout = 5000) {
        this.url = url;
        this.formatType = formatType;
        this.timeout = timeout;
        this.socket = null;
        this.pingInterval = 0;
        this.onmessage = (data) => { };
    }
    async open() {
        return new Promise((resolve, reject) => {
            const ref = globalThis.setTimeout(() => {
                reject();
                this.close();
            }, this.timeout);
            this.socket = new WebSocket(this.url + `?msgtype=${this.formatType}`);
            this.socket.onopen = () => {
                globalThis.clearTimeout(ref);
                this.startPing();
                resolve(true);
            };
            this.socket.onclose = (event) => {
                globalThis.clearInterval(this.pingInterval);
                this.onmessage({
                    type: 'close',
                    data: {
                        event: {
                            code: event.code
                        }
                    }
                });
            };
            if (this.formatType === 'msgpack') {
                this.socket.binaryType = 'arraybuffer';
            }
            this.socket.onmessage = message => {
                try {
                    let data;
                    if (this.formatType === 'msgpack') {
                        data = msgpack.decode(new Uint8Array(message.data));
                    }
                    else {
                        data = JSON.parse(message.data);
                    }
                    this.parseMessageJson(data);
                }
                catch (ex) {
                    console.error(ex);
                }
            };
        });
    }
    close() {
        globalThis.clearInterval(this.pingInterval);
        if (this.socket) {
            this.socket.onclose = () => { };
            this.socket.close(1000);
        }
    }
    send(json) {
        if (!this.socket) {
            return false;
        }
        if (this.socket.readyState !== 1) {
            return false;
        }
        if (this.formatType === 'msgpack') {
            this.socket.send(msgpack.encode(json));
        }
        else {
            this.socket.send(JSON.stringify(Object.assign({}, json)));
        }
        return true;
    }
    startPing() {
        this.pingInterval = globalThis.setInterval(() => {
            this.send({
                ping: 101
            });
        }, 1000);
    }
    parseMessageJson(json) {
        if (json.setToken) {
            this.onmessage({ type: 'token', data: { token: json.setToken } });
        }
        if (json.hmacAuthRequest) {
            this.send({
                hmacAuthResponse: HMACAuthenticator.response(json.hmacAuthRequest.data, 'webclient', '')
            });
            this.onmessage({ type: 'authed' });
            return;
        }
        if (json.data) {
            this.onmessage({
                type: 'message',
                data: {
                    message: json.data
                }
            });
        }
    }
}
exports.DirectHubConnection = DirectHubConnection;
//# sourceMappingURL=DirectHubConnection.js.map